module.exports = __webpack_public_path__ + "static/media/image-video-processing.7f5a20ff.svg";